<template>
  <div role="tablist">
    <template v-for="group in group(value)">
      <postcode-accordion :key="group.id" :group="group" @remove="remove" @removeGroup="removeGroup" />
    </template>
  </div>
</template>

<script>
import groupPostcodes from "@/imports/mixins/groupBasketPostcodes";
import PostcodeAccordion from "@/components/list/PostcodeAccordion";
import notification from "@/imports/mixins/notification";
export default {
  name: "Basket",
  components: {PostcodeAccordion},
  mixins: [groupPostcodes, notification],
  props: ['value'],
  methods: {
    removeGroup: function(areaCode) {
      this.notify(
        this.$bvToast,
        `All post codes in area "${areaCode}" removed`,
        null,
        'success'
      );
      this.$emit(
        'input',
        this.value
          .filter(postCode => postCode.parent.name !== areaCode)
          .sort((a,b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
      );
    },
    remove: function(postCode) {
      this.notify(
        this.$bvToast,
        `Post code "${postCode.name}" removed`,
        null,
        'success'
      );
      this.$emit(
        'input',
        this.value
          .filter(pc => pc.id !== postCode.id)
          .sort((a,b) => a.name
            .localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'}))
      );
    }
  }
}
</script>

<style scoped>

</style>
